import React, { createContext, useContext, useState, useEffect } from 'react'

const OrientationContext = createContext()

export const useOrientation = () => {
  const context = useContext(OrientationContext)
  if (!context) {
    throw new Error('useOrientation must be used within OrientationProvider')
  }
  return context
}

export const OrientationProvider = ({ children }) => {
  const [isPortrait, setIsPortrait] = useState(false)

  useEffect(() => {
    const checkOrientation = () => {
      setIsPortrait(window.innerHeight > window.innerWidth)
    }

    checkOrientation()
    window.addEventListener('resize', checkOrientation)
    window.addEventListener('orientationchange', checkOrientation)

    return () => {
      window.removeEventListener('resize', checkOrientation)
      window.removeEventListener('orientationchange', checkOrientation)
    }
  }, [])

  return (
    <OrientationContext.Provider value={{ isPortrait }}>
      {children}
    </OrientationContext.Provider>
  )
}
